export enum api {
  AUTH_URL = '/auth',
  BIDS_URL = '/bids',
  DASHBOARDS_URL = '/dashboards',
  ENUMERATION_URL = '/enumerations',
  FILE_URL = '/files',
  FIXED_ASSETS_URL = '/fixed-assets',
  INVOICES = '/invoices',
  JOB_URL = '/jobs',
  NOTE_URL = '/notes',
  PARTIES_URL = '/parties',
  PERMISSIONS_URL = '/permissions',
  PROPERTIES_URL = '/properties',
  SAVED_FILTERS_URL = '/saved-filters',
  SERVICES_CATEGORIES = '/services/categories',
  SERVICES_REGIONS = '/service-regions',
  SERVICES_SUBCATEGORIES = '/services/subcategories',
  SERVICES_URL = '/services',
  TOUCHES_URL = '/touches',
  USER_ROLE_TYPES_URL = '/user-role-types',
  USER_URL = '/users',
  VENDOR_SERVICES = '/vendor-services',
  VENDOR_INSURANCE_COVERAGE_URL = '/vendor-insurance-coverages',
  VENDOR_INSURANCE_POLICY_URL = '/insurance-policies',
  VENDOR_URL = '/vendors',
  VISITS_URL = '/visits',
  WORK_ORDERS_URL = '/work-orders',
}

export enum EnumType {
  JOB_STATUS = 'job-status',
  WORK_ORDER_PARTICIPANT_TYPE = 'work-order-participant-type',
  STATE = 'state',
  JOB_TYPE = 'job-type',
  USER_STATUS = 'user-status',
  WORK_ORDER_STATUS = 'work-order-status',
  WORK_ORDER_PRIORITY = 'work-order-priority',
  PERMISSION_CATEGORY = 'permission-category',
  PERMISSION_SUBCATEGORY = 'permission-subcategory',
  BID_STATUS = 'bid-status',
  WORK_ORDER_OCCUPANCY_STATUS = 'work-order-occupancy-status',
  INVOICE_STATUS = 'invoice-status',
  WORK_ORDER_SCOPE_ITEM_STATUS = 'work-order-scope-item-status',
}
